import icons from '../assets/iconfont/iconfont.json';

// let server = "http://localhost:8080";
// let server = "http://127.0.0.1:8080"
let server = process.env.NODE_ENV === 'production' 
    ? ""
    // : "http://192.168.1.69:8080";
    : "http://192.168.2.107:8080";
    // : "http://localhost:8080";
let kit =  {
    api:{
        server: server,
        docUrl: server+"/static/",
        companyInfo: server+"/api/p/companyInfo",
        companyImg: server+"/api/p/getCompanyImgId",
        login: server+"/am/auth/login",  //登录
        reg: server+"/am/auth/reg",  //注册
        logout: server+"/am/auth/quitLogin",  //注销
        code: server+"/api/p/code1",         //验证码ss
        shopeeDetail: server+"/api/p/shopeeDetail",         //产品详情 stockId, title
        shopeeDetail1: server+"/api/p/shopeeDetail1",         //产品详情 detailId
        barcode: server+"/api/p/barcode",         //条形码
        convertUrl: server+"/api/p/convertUrl",         //转换URL
        getPddOrderId: server+"/api/p/getPddOrderId",         //获取拼多多采购单号

        getExpCompany: server+"/am/exp-company-page/getExpCompany",

        langs: server+"/api/p/langs",
        resources: server+"/api/p/resources",
        addResources: server+"/api/p/addResources",
        imgView: server + "/api/p/file?id=",
        upload:server+"/am/attachment/upload",
        uploadChatImg:server+"/am/attachment/uploadChatImg",
        tplDownload: server+"/static/default-tpl.xlsx",
        jbDownload:server+"/static/Gprinter_2021.3_M-0.exe",
        
        // chromeDownload:server+"/static/shunyunbao-plugin-0.1.3.zip",
        chromeDownload1:server+"/static/"+encodeURIComponent('顺运宝采购插件1.1.9.zip'),
        chromeDownloadNew:server+"/static/"+encodeURIComponent('采购助手20250912(先解压).zip'),
        pdaDownload:server+"/static/"+encodeURIComponent('SYB-PDA_v1.9.2.apk'),
        // pdaDownloadPhone:server+"/static/"+encodeURIComponent('SYB-PDA_v1.6_phone.apk'),
        pdfDownload:server+"/static/"+encodeURIComponent('顺运宝PDF打印服务安装程序_v1.1.exe'),
        pdfDownloadTw:server+"/static/"+encodeURIComponent('顺运宝PDF打印服务安装程序_TW_v1.1.exe'),
        dlDownloadNew:server+"/static/"+encodeURIComponent('NEW系列驱动程序.exe'),
        dlDownload:server+"/static/"+encodeURIComponent('得力条码打印机不带NEW系列驱动程序.exe'),
        dept:{
            list: server+"/am/dept/list",
            listByDataPath:server+"/am/dept/listByDataPath",
            listByDataPathGrant:server+"/am/dept/listByDataPathGrant",
            create: server+"/am/dept/create",
            update: server+"/am/dept/update",
            updateCompany: server+"/am/dept/updateCompany",
            updatePageSender: server+"/am/dept/updatePageSender",
            delete: server+"/am/dept/delete",
            deleteLogo: server+"/am/dept/deleteLogo",
            grantStore: server+"/am/dept/grantStore",
            getDetail: server+"/am/dept/getDetail",
        },
        menu: {
            all: server + "/am/menu/all",
            create: server + "/am/menu/create",
            update: server + "/am/menu/update",
            delete: server + "/am/menu/delete",
            toggle: server + "/am/menu/toggle", //根据角色获取菜单
            curr: server + "/am/menu/curr", //当前登录用户的菜单
        }, 
        permission: {
            list:server+"/am/permission/list" ,  //权限
            create:server+"/am/permission/create" , 
            update:server+"/am/permission/update" , 
            deletes:server+"/am/permission/deletes" , 
            toggle: server+"/am/permission/toggle",  //根据角色获取权限
        },  

        role:{
            list:server+"/am/role/list",
            create:server+"/am/role/create",
            update:server+"/am/role/update",
            delete:server+"/am/role/delete",
            menuUpdate: server + "/am/role/updateMenu", //分配菜单
            grantPermission: server + "/am/role/updatePermission", //分配权限
            grantCol: server + "/am/role/updateViewColumns", //分配字段权限
            btnsByCheck:server + "/am/role/btnsByCheck", 
            updateViewBtns:server + "/am/role/updateViewBtns", 
            updateRoleRefs:server + "/am/role/updateRoleRefs",  //分配引用角色
            roleRefs:server + "/am/role/roleRefs",  //获取引用角色
            updateViews:server + "/am/role/updateViews",  //分配视图
            viewUsers:server + "/am/role/viewUsers",  //获取视图引用
            copyRole:server + "/am/role/copyRole",//复制角色
        },

        lang:{
            languageList:server+"/am/lang/lanList",
            languageCreate:server+"/am/lang/lanCreate",
            languageUpdata:server+"/am/lang/lanUpdate",
            languageDelete:server+"/am/lang/lanDelete",

            resourceList:server+"/am/lang/resList",
            resourceUpdata:server+"/am/lang/resUpdate",
            resourceCreate:server+"/am/lang/resCreate",
            getRes:server+"/am/lang/getResources",
        },

        setting:{
            settingRoot: server+"/am/setting/root",
            settingList: server+"/am/setting/list",
            settingCreate: server+"/am/setting/create",
            settingUpdate: server+"/am/setting/update",
            settingDelete: server+"/am/setting/delete", 
        },
        
        user:{
            get: server+"/am/user/get", 
            getVipSet: server+"/am/user/getVipSet", 
            updateBuyType: server+"/am/user/updateBuyType", 
            list: server+"/am/user/list", 
            create: server+"/am/user/create", 
            update: server+"/am/user/update", 
            delete: server+"/am/user/delete",
            grantData: server+"/am/user/grantData",
            datapath: server+"/am/user/datapath",
            updateSimple: server+"/am/user/updateSimple",  //更新用户基本信息
            updatePhoto: server+"/am/user/updatePhoto",
            friends: server+"/am/user/friends", //获取好友列表
            search: server+"/am/user/search",   //查找用户
            addFriend: server+"/am/user/addFriend",   //添加好友
            delFriend: server+"/am/user/delFriend",   //删除好友
            remarkFriend: server+"/am/user/remarkFriend",   //修改好友备注
            changePwd:server+"/am/user/changePwd",   //修改密码
            clearStrongPwd:server+"/am/user/clearStrongPwd",   //清除用户安全密码
            comTest: server+"/static/res/COMTest.zip",
            settingUpdate: server+"/am/user/setting/update",
            settingList: server+"/am/user/setting/list",
            ecConfig: server+"/am/user/setting/ecConfig",
            tpConfig: server+"/am/user/setting/tpConfig",
            qgConfig: server+"/am/user/setting/qgConfig",
            pwConfig:server+"/am/user/setting/pwConfig",//打印提醒
            configs: server+"/am/user/setting/config",
            saveOrUpdateConfigByKey: server+"/am/user/setting/saveOrUpdateByKey",
            deleteConfigByKey: server+"/am/user/setting/deleteByKey",
            runAs:server+"/am/user/runAs",
            disabled:server+"/am/user/disable",
            checkVipKey:server+"/am/user/checkVipKey",
            reloadUser: server+"/am/user/reloadPermission",
            editStatus: server+"/am/user/editStatus",
            updateToken: server+"/am/user/updateToken",
            updatePageTag: server+"/am/user/updatePageTag",
            isStrongAuth: server+"/am/user/isStrongAuth",
            strongAuth: server+"/am/user/strongAuth",
            updateProfile: server+"/am/user/updateProfile",
            updateRemark: server+"/am/user/updateRemark",
            updateSortingOutlet: server+"/am/user/updateSortingOutlet",
            updateStall: server+"/am/user/updateStall",
            updateSettler: server+"/am/user/updateSettler",
            updateSettlerUsername: server+"/am/user/updateSettlerUsername",
            updateAgreementStatus: server+"/am/user/updateAgreementStatus",
            agreeUserAgreement: server+"/am/user/agreeUserAgreement",
            checkNeedAgreement: server+"/am/user/checkNeedAgreement",
            checkUserShopAndOrder: server+"/am/user/checkUserShopAndOrder",
            updateIdCard: server+"/am/user/updateIdCard",
            importSettleAccount: server+"/am/user/importSettleAccount",
            setting: {
                view: {
                    loadViewByType: server + "/am/user/view/setting/loadViewByType",
                    saveOrUpdate: server + "/am/user/view/setting/saveOrUpdate",
                    deleteView: server + "/am/user/view/setting/delete"
                }
            }
        },
        wallet: {
            checkLoginPwd: server+"/am/wallet/checkLoginPwd", //检查登录密码
            checkWalletPwd: server+"/am/wallet/checkWalletPwd", //检查提现密码
            checkCompanyWord: server+"/am/wallet/checkCompanyWord", //检查开户公司结算口令
            checkCompanyPwd: server+"/am/wallet/checkCompanyPwd", //检查开户公司结算密码
            details: server+"/am/wallet/details", //获取流水详情
            get: server+"/am/wallet/balance", //获取钱包信息
            list: server+"/am/wallet/list", //获取所有
            listForDetail: server+"/am/wallet/listForDetail", //费用清单list
            create: server+"/am/wallet/create",//开户
            updateCompany: server+"/am/wallet/updateCompany",//更新开户公司
            updateLoan: server+"/am/wallet/updateLoan",//更新信用额度
            updatePoint: server+"/am/wallet/updatePoint",//更新积分
            updateWalletPassword: server+"/am/wallet/updateWalletPassword",
            cashIn: server+"/am/wallet/cashIn", //充值
            cashOut: server+"/am/wallet/cashOut", //提现
            finish: server+"/am/wallet/finish", //完成
            cancel: server+"/am/wallet/cancel", //取消
            doImport: server+"/am/wallet/doImport", //导入
            doAppendFee: server+"/am/wallet/doAppendFee", //追加费用导入
            doImportRemark: server+"/am/wallet/importRemark", //导入
            importTransport: server+"/am/wallet/importTransport", //导入运费
            delete: server+"/am/wallet/delete", //
            remark: server+"/am/wallet/remark", //备注
            findStocks: server+"/am/wallet/findStocks",
            deleteWallet: server+"/am/wallet/deleteWallet",
            doFreight: server+"/am/wallet/doFreight",
            showTip: server+"/am/wallet/showTip",
            updateRemark1: server+"/am/wallet/updateRemark1",
            updatePayStatus: server+"/am/wallet/updatePayStatus",
            updateWalletDetailImg: server+"/am/wallet/updateWalletDetailImg",
            getOwnerCompanyIds: server+"/am/wallet/getOwnerCompanyIds",
        },
        pointDetail:{
            list: server+"/am/point-detail/list", 
        },
        coupon:{
            list: server+"/am/coupon/list", 
            create: server+"/am/coupon/create", 
        },
        vip: {
            listView: server+"/am/vip/listView", //获取vip列表
            prices: server+"/am/vip/prices", //获取vip价格
            orders: server+"/am/vip/orders", //获取会员支付订单
            query: server+"/am/vip/queryPayResult", //查询支付进度
            queryFree: server+"/am/vip/queryPayResultFree", //查询支付进度
            deleted: server+"/am/vip/delete", //删除
            checkBuy: server+"/am/vip/checkBuy", //检测是否能够购买
            checkBuyEnable: server+"/am/vip/checkBuyEnable",
            checkOrderStatus:server+"/am/vip/checkOrderStatus", 
            cancelOrder:server+"/am/vip/cancelOrder", 
            buy: server+"/am/vip/buy", //购买会员
            jsonSetting: server+"/am/vip/jsonSetting", //购买会员
            setting: server+"/am/vip/setting",
        },
        offer: {
            list: server+"/am/offer/list", //获取报价设置列表
            detail: server+"/am/offer/detail", //获取报价设置详情
            create: server+"/am/offer/create", //创建报价设置
            updateRemark: server+"/am/offer/updateRemark", //批量更新备注
            updateUsed: server+"/am/offer/updateUsed",//批量调用
            copyOf: server+"/am/offer/copyOf", //复制报价到指定的客户
            deletes: server+"/am/offer/deletes", //删除指定的报价设置
            edit: server+"/am/offer/edit", //编辑报价
            resetTransit: server+"/am/offer/resetTransit", //运费设置
            resetDelivery: server+"/am/offer/resetDelivery", //交派费设置
            resetPkg: server+"/am/offer/resetPkg", //交派费设置
            resetPasteBill: server+"/am/offer/resetPasteBill", //贴单费设置
            resetProxy: server+"/am/offer/resetProxy", //贴单费设置
            resetRate: server+"/am/offer/resetRate", //汇率设置
        },
        financeOffer:{
            list: server+"/am/finance-offer/list", //获取报价设置列表
            doImport: server+"/am/finance-offer/doImport", //批量导入报价(财务)
            deletes: server+"/am/finance-offer/deletes", //删除指定的报价设置(财务)
            updateDefaultUsed: server+"/am/finance-offer/updateDefaultUsed", //切换是否默认（全局唯一）
            myOffer: server+"/am/finance-offer/myOffer", //按账号查询该账号在默认/最新报价下的全部子表
        },
        financeCompute:{
            compute: server+"/am/finance-compute/compute", //执行运费计算（异步开跑）
            progress: server+"/am/finance-compute/progress", //查询运费计算进度
            finish: server+"/am/finance-compute/finish", //前端结算完成后清理session进度
        },
        message: {
            list: server+"/am/msg/list",                //消息列表
            deletes: server+"/am/msg/deletes",          //删除消息
            totalUnread: server+"/am/msg/totalUnread",  //获取未读消息总数
            send: server+"/am/msg/send",                //发送消息
            totalGroupUnread: server+"/am/msg/totalGroupUnread", //根据用户汇总消息总数
            userList: server+"/am/msg/userList",        //获取用户的获取消息列表
            markRead: server+"/am/msg/markRead",        //标记为已读
            deleteByUser: server+"/am/msg/deleteByUser",         //根据用户删除消息
        },
        workorder: {
            list: server+"/am/workorder/list",                //工单列表
            detail: server+"/am/workorder/detail",
            create: server+"/am/workorder/create",
            createbatch: server+"/am/workorder/createbatch",
            delete: server+"/am/workorder/delete",
            comment: server+"/am/workorder/comment",
            listcount: server+"/am/workorder/listcount",
            finish: server+"/am/workorder/finish",
            servicelist: server+"/am/workorder/servicelist",
            typelist: server+"/am/workorder/typelist",
            otherservicelist: server+"/am/workorder/otherservicelist",
            process: server+"/am/workorder/process",
            typeChange: server+"/am/workorder/typeChange",
            typeDescChange: server+"/am/workorder/typeDescChange",
            levelChange: server+"/am/workorder/levelChange",
            change: server+"/am/workorder/change",
            workOrderCount: server+"/am/workorder/workOrderCount",
            workOrderCountList: server+"/am/workorder/workOrderCountList",
        },
        workordermsg: {
            list: server+"/am/workordermsg/list",                //消息列表
            deletes: server+"/am/workordermsg/deletes",          //删除消息
            totalUnread: server+"/am/workordermsg/totalUnread",  //获取未读消息总数
            send: server+"/am/workordermsg/send",                //发送消息
            listbyorder: server+"/am/workordermsg/listByOrder",        //获取用户的获取消息列表
            markRead: server+"/am/workordermsg/markRead",        //标记为已读
            deleteByUser: server+"/am/workordermsg/deleteByUser",         //根据用户删除消息
        },
        viewSetting: {
            get: server+"/am/view-setting/get", 
            list: server+"/am/view-setting/list", 
            listByType: server+"/am/view-setting/listByType", 
            tables: server+"/am/view-setting/tablesByLogin", 
            checked: server+"/am/view-setting/tablesByCheck", 
            create: server+"/am/view-setting/create", 
            update: server+"/am/view-setting/update", 
            delete: server+"/am/view-setting/delete", 
            seq: server+"/am/view-setting/sort", 
            defaulted: server+"/am/view-setting/defaulted", 
            defaultView: server+"/am/view-setting/defaultView", 
            setting: server+"/am/view-setting/setting", 
        },
        attachment:{
            list: server+"/am/attachment/list", 
            delete: server+"/am/attachment/delete", 
            upload: server+"/am/attachment/upload", 
            getCloudUrl: server+"/am/attachment/getCloudUrl", // BOS 下载前取签名URL
        },
        history:{
            list: server + "/am/history/list",
            loginlist: server + "/am/history/loginlist",
            create: server + "/am/history/create",
        },
        notice:{
            get:server+"/am/notice/get", 
            send:server+"/am/notice/send", 
            myList:server+"/am/notice/myList", 
            list:server+"/am/notice/list", 
            myDelete:server+"/am/notice/myDelete", 
            delete:server+"/am/notice/delete", 
            updateStatus:server+"/am/notice/updateStatus", 
            attachment:server+"/am/notice/getFileList",
            warnList:server+"/am/notice/remindList",
            deleteShow:server+"/am/notice/deleteShow",
            findUserByDeptId:server+"/am/notice/findUserByDeptId",
            findUserByNames:server+"/am/notice/findUserByNames",
            findUsersByNoticeId:server+"/am/notice/findUsersByNoticeId",
        },
        video:{
            list:server+"/am/video/list", 
            add:server+"/am/video/add", 
            edit:server+"/am/video/edit", 
            delete:server+"/am/video/delete", 
        },  
        stock:{
            getStockByIds:server+"/am/stock/getStockByIds", 
            getStockById:server+"/am/stock/getStockById", 
            getZhuanyunByIds:server+"/am/stock/getZhuanyunByIds", 
            getWeightByIds:server+"/am/stock/getWeightByIds", 
            getStockDetailsByIds:server+"/am/stock/getStockDetailsByIds", 
            list:server+"/am/stock/list", 
            listTotal: server+"/am/stock/listTotal",
            detailList:server+"/am/stock/detailList", 
            expressOrderList:server+"/am/stock/expressOrderList", 
            expOrderAdd:server+"/am/stock/expOrderAdd", 
            expOrderEdit:server+"/am/stock/expOrderEdit",
            expOrderDelete:server+"/am/stock/expOrderDelete",
            reportList:server+"/am/stock/reportList", 
            reportListForSj:server+"/am/stock/reportListForSj", 
            checkHistList:server+"/am/stock/checkHistList", 
            get:server+"/am/stock/get",
            getStore: server+"/am/stock/getStore",
            create:server+"/am/stock/create",
            update:server+"/am/stock/update",
            delete:server+"/am/stock/delete",
            deleteOne:server+"/am/stock/deleteOne",
            configList: server+"/am/stock/import/configList",
            configAdd: server+"/am/stock/import/configAdd",
            configDelete: server+"/am/stock/import/configDelete",
            doImport: server+"/am/stock/import/doImport",
            detail:server+"/am/stock/detail",
            checkUploadPermission:server+"/am/stock/checkUploadPermission",
            pageImport:server+"/am/stock/pageImport",
            pageImport1:server+"/am/stock/pageImport1",
            onlyPageImport:server+"/am/stock/onlyPageImport",
            batchUpdate: server + "/am/stock/batchUpdate",
            batchUpdateNew: server + "/am/stock/batchUpdateNew",
            updateColumn:server + "/am/stock/updateColumn",
            inout: server + "/am/stock/inout", //出仓入仓
            checkSaveBatchPkg: server + "/am/stock/inout/checkSaveBatchPkg",  //检测袋号
            getPrintData: server + "/am/stock/inout/print", //获取打印数据
            getStockSelect:server + "/am/stock/getStockSelect",
            stockAddPkg:server + "/am/stock/stockAddPkg",
            getStockAndDetail:server + "/am/stock/getStockAndDetail",
            stockErrorAdd:server + "/am/stock/stockErrorAdd",
            weightShare:server + "/am/stock/weightShare",
            allowUpload:server + "/am/stock/allowUpload",
            doZhuanYun:server + "/am/stock/doZhuanYun",
            updateError: server + "/am/stock/updateError",
            //物流跟踪详情
            traces: server + "/am/stock/traces",
            tracesNew: server + "/am/stock/tracesNew",
            //线下建单
            offlineCreate: server + "/am/stock/offlineCreate",
            getPkgCodes:server + "/am/stock/getPkgCodes",
            updatePkgCode:server + "/am/stock/updatePkgCode",
            autoSavePkgCode:server + "/am/stock/autoSavePkgCode",
            getPrintFindData:server + "/am/stock/print/getPrintFind",
            getPrintPkgCodeData:server + "/am/stock/print/getPrintPkgCodeData",
            findPkgPage:server + "/am/stock/print/findPrintPkgPage",
            finishPackage:server + "/am/stock/finishPackage",
            doTrack:server + "/am/stock/doTrack",//货态同步
            doTrackExpress:server + "/am/stock/doTrackExpress",//快递同步
            doAutoSyncExpress:server + "/am/stock/doAutoSyncExpress",//自动获取快递单号
            doSaveInnerExpCode:server + "/am/stock/doSaveInnerExpCode",
            updateRemark:server + "/am/stock/updateRemark",//更新备注
            updateRemarks:server + "/am/stock/updateRemarks",
            updateDetailCodes:server + "/am/stock/updateDetailCodes",//批量更新详情订单编号和架位号
            // batchSendOrder:server + "/am/stock/batchSendOrderOld",//一键发货
            batchSendOrder1:server + "/am/stock/batchSendOrder1",//空白面单
            batchSendOrderNew:server + "/am/stock/batchSendOrderNew",//一键发货新逻辑
            expressSorting:server + "/am/stock/expressSorting",//快递分拣
            stockSorting:server + "/am/stock/stockSorting",//库存分拣
            getPici:server + "/am/stock/getPici",//获取批次
            getPiciByDate:server + "/am/stock/getPiciByDate",//根据日期获取批次
            getPkgCodeByIds:server + "/am/stock/getPkgCodeByIds",//根据库存ID获取袋号
            printPkgTicket:server + "/am/stock/print/printPkgTicket",
            printPkgTicketAuto:server + "/am/stock/print/printPkgTicketAuto",
            printPkgTicketAutoP:server + "/am/stock/print/printPkgTicketAutoP",
            printRealTicket:server + "/am/stock/print/printRealTicket",
            stockSplit:server + "/am/stock/stockSplit",//详情分拆
            detailCreate:server + "/am/stock/detailCreate",//详情分拆-添加详情
            getErrList:server + "/am/stock/getErrList",
            getFastPrintData:server + "/am/stock/print/fastPrint",
            getZhuanyunData:server + "/am/stock/getZhuanyunData",//获取集运转运数据
            getQijianData:server + "/am/stock/getQijianData",//获取弃件数据
            doQijian:server + "/am/stock/doQijian",
            stockCheckCode:server + "/am/stock/stockCheckCode",//条码校对
            initCode:server + "/am/stock/initCode",
            createCode:server + "/am/stock/createCode",
            createStore:server + "/am/stock/createStore",
            checkCodes:server + "/am/stock/checkCodes",
            updateDetailReport:server + "/am/stock/updateDetailReport",
            detailThumb:server + "/am/stock/detailThumb",
			qrupp:server + "/am/stock/qrUpp", //二维码上架
			printCodeAsBarCode:server + "/am/stock/print/printCodeAsBarCode", //将订单编号打印成条形码
            printExpCodeAsBarCode:server + "/am/stock/print/printExpCodeAsBarCode", 
            printShopNameAsBarCode:server + "/am/stock/print/printShopNameAsBarCode", //将订单编号打印成条形码
            printBagCodeAsBarcode:server + "/am/stock/print/printBagCodeAsBarcode", //将货包号打印成条形码
            acceptReport:server+"/am/stock/acceptReport",//报单受理
            updateMark:server+"/am/stock/updateMark",//货物采购-点到
            cancelReport:server+"/am/stock/cancelReport",//撤销受理
            detailBuyViewList:server+"/am/stock/detailBuyViewList",
            deleteBatchById:server+"/am/stock/deleteBatchById",
            updateRemark1:server+"/am/stock/updateRemark1",
            zhuanyunCharge:server+"/am/stock/zhuanyunCharge",
            selectStatusById:server+"/am/stock/selectStatusById",
            getOfflinePage:server+"/am/stock/getOfflinePage",
            getOfflineExpCode:server+"/am/stock/getOfflineExpCode",
            syncXzAddressCode:server+"/am/stock/syncXzAddressCode",
            checkCode:server+"/am/stock/checkCode",
            expCodeSave:server+"/am/stock/expCodeSave",
            packSave:server+"/am/stock/packSave",
            noticeSend:server+"/am/stock/noticeSend",
            searchKuaidiCode:server+"/am/stock/searchKuaidiCode",
            updateKuaidi:server+"/am/stock/updateKuaidi",
            makeBatchCode:server+"/am/stock/makeBatchCode",
            stockHandover:server+"/am/stock/stockHandover",
            xuniReceiveStock:server+"/am/stock/xuniReceiveStock",
            stockDetailTongji:server+"/am/stock/stockDetailTongji",//库存管理统计
            editDetailReady:server+"/am/stock/editDetailReady",
            editDetailLeast:server+"/am/stock/editDetailLeast",
            editStockStatus:server+"/am/stock/editStockStatus",
            editDetailBuyLink:server+"/am/stock/editDetailBuyLink",
            editDetailRemark:server+"/am/stock/editDetailRemark",
            editStockCreated:server+"/am/stock/editStockCreated",
            getDetailByInnerCode:server+"/am/stock/getDetailByInnerCode",
            checkWalletStatus:server+"/am/stock/checkWalletStatus",
            saveVideoImg:server+"/am/stock/saveVideoImg",
            doUpdateCompany:server+"/am/stock/doUpdateCompany",
            saveBatch:server+"/am/stock/batch/save",//保存批次
            getBatchList:server+"/am/stock/batch/getPici",//查询批次
            pagePicExport:server+"/am/stock/pagePicExport",//导出面单
            changeOrderPlatform:server+"/am/stock/changeOrderPlatform",//更新订单来源平台，将虾皮改为虾皮离线
            updateRetrunCode:server+"/am/stock/updateRetrunCode",//录退件码
            checkPrinter:server+"/am/stock/checkPrinter",
            updatePlatFormAndCredit:server+"/am/stock/updatePlatFormAndCredit",
            handelCancel:server+"/am/stock/handelCancel",
            cancelShopeeOrder:server+"/am/stock/cancelShopeeOrder",
        },
        checkHistList:{
            list:server + "/am/check-hist/checkHistList",//核单记录
            listReport:server + "/am/check-hist/checkHistListReport",//核单记录
        },
        print:{
            printCustom:server + "/am/stock/print/printCustom",//自定义打印
        },
        stockDetail: {
            listByStock:server + "/am/stock/detail/listByStock",//预览详情第一版
            listByStock1:server + "/am/stock/detail/listByStock1",//预览详情第二版
            listByStockNew:server + "/am/stock/detail/listByStockNew",//店铺订单
            checkBuyLink:server + "/am/stock/detail/checkBuyLink",//店铺订单
            listByStock1Total:server + "/am/stock/detail/listByStock1Total",
            updateDetailCode:server + "/am/stock/detail/updateDetailCode",//更新详情订单编号和架位号
            updateDetailVariationSku:server + "/am/stock/detail/updateDetailVariationSku",  //更新货号和SKU
            updateDetailCosts:server + "/am/stock/detail/updateDetailCosts", //更新详情成本
            updateDetailStore:server + "/am/stock/detail/updateDetailStore",  //更新详情到货仓库
            updateExpGoodType:server + "/am/stock/detail/updateExpGoodType",
            deleteInnerCode:server + "/am/stock/detail/deleteInnerCode",  //清除快递单号和架位号
            deleteInnerCodes:server + "/am/stock/detail/deleteInnerCodes",  //批量清除快递单号和架位号
            updateDetailMark:server + "/am/stock/detail/updateDetailMark",//更新详情，点到
            deleteDetail:server + "/am/stock/detail/deleteDetail", //删除详情
            getPurchaseLink:server + "/am/stock/detail/getPurchaseLink",//获取采购链接
            openBuyLink:server + "/am/stock/detail/openBuyLink",       //搜索采购链接表，查找对应链接
            openBuyLinks:server + "/am/stock/detail/openBuyLinks",     //批量搜索采购链接表，查找对应链接
            updateDetailPurchaseCode:server + "/am/stock/detail/updateDetailPurchaseCode",  //更新采购单号
            updateDetailPurchaseCodes:server + "/am/stock/detail/updateDetailPurchaseCodes", //批量更新采购单号
            rebackDetailPurchaseCode:server + "/am/stock/detail/rebackDetailPurchaseCode",   //撤销已采购单号
            rebackDetailPurchaseCodes:server + "/am/stock/detail/rebackDetailPurchaseCodes",   //批量撤销已采购单号
			createDetail:server + "/am/stock/detail/createDetail",  //添加一条详情
            detailBuyList:server+"/am/stock/detail/detailBuyList",//货物采购list
            getInventoryQty:server+"/am/stock/detail/getInventoryQty",//货物采购list
            getPurchseLink:server+"/am/stock/detail/getPurchseLink",//获取采购链接
            getDetailEditList:server+"/am/stock/detail/getDetailEditList",//详情修改list
            stockQtyEditList:server+"/am/stock/detail/stockQtyEditList",//入库出库list
            updateQty:server+"/am/stock/detail/updateQty",//入库出库更新
            updateProductName:server+"/am/stock/detail/updateProductName",//更新品名
            updateDetail:server+"/am/stock/detail/updateDetail",//详情修改
            updateProductSpec:server+"/am/stock/detail/updateProductSpec",//更新规格
            updateTransport:server+"/am/stock/detail/updateTransport",
            updateExpCompany:server+"/am/stock/detail/updateExpCompany",
            getReceiverTel:server+"/am/stock/detail/getReceiverTel",
            orderInfo: server + "/am/stock/detail/orderInfo", //订单信息的简单页面
            orderInfo1: server + "/am/stock/detail/orderInfo1", //订单信息的简单页面
            orderSplitList: server + "/am/stock/detail/orderSplitList", //订单拆分list
            orderSplitSave: server + "/am/stock/detail/orderSplitSave", //保存订单拆分结果
            getDetailsByStockId: server + "/am/stock/detail/getDetailsByStockId",
            orderPkgSave: server + "/am/stock/detail/orderPkgSave",
        },
        finance: {
            transitTypeList:server+"/am/finance/transitTypeList",//收费方式list
            updateTransitType:server+"/am/finance/updateTransitType",//更新收费方式
            computeTransit:server+"/am/finance/computeTransit",//运费计算
            transitPercent:server+"/am/finance/transitPercent",//运费计算进度
            transitComputeFinish:server+"/am/finance/transitComputeFinish",//标记完成
            computeProxy:server+"/am/finance/computeProxy",//回款计算
            proxyPercent:server+"/am/finance/proxyPercent",//回款计算进度
            proxyComputeFinish:server+"/am/finance/proxyComputeFinish",//标记完成
            computeLipei:server+"/am/finance/computeLipei",//理赔计算
            lipeiPercent:server+"/am/finance/lipeiPercent",//理赔计算进度
            lipeiComputeFinish:server+"/am/finance/lipeiComputeFinish",//标记完成
            computeKesu:server+"/am/finance/computeKesu",//客诉件计算
            kesuPercent:server+"/am/finance/kesuPercent",//客诉件计算进度
            kesuComputeFinish:server+"/am/finance/kesuComputeFinish",//客诉件标记完成
        },
        resend: {
            preview: server + "/am/stock/resend/preview", //与匹配转寄，
            search: server + "/am/stock/resend/search",  //搜索
            save: server + "/am/stock/resend/save",  //搜索
            findExps: server + "/am/stock/resend/findExps",  //搜索
            searchSku: server + "/am/stock/resend/searchSku",
        },
        store: {
            get: server+"/am/store/get",
            list: server+"/am/store/list",
            create: server+"/am/store/create",
            update: server+"/am/store/update",
            delete: server+"/am/store/delete",
            listUsed: server+"/am/store/listByUsed",
            listByUsedOwner: server+"/am/store/listByUsedOwner",
            listByOwn: server+"/am/store/listByOwn",
            listAll:server+"/am/store/listAll",
            storeTypes: server+"/am/store/storeTypes",
            checkStore:server+"/am/store/checkStore",
        },
        company: {
            list: server+"/am/company/list",
            listByDataPath: server+"/am/company/listByDataPath",
            create: server+"/am/company/create",
            update: server+"/am/company/update",
            delete: server+"/am/company/delete",
        },
        shop: {
            get: server+"/am/shop/get",
            list: server+"/am/shop/list",
            delete: server+"/am/shop/delete",
            bind: server+"/am/shop/bind",
            syncShop: server+"/am/shop/sync",
            editName: server + "/am/shop/editName",
            syncOrder: server + "/am/shop/syncOrder",
            checkShopNum: server + "/am/shop/checkShopNum",
            getShopQty: server + "/am/shop/getShopQty",
            getShopQtyNum: server + "/am/shop/getShopQtyNum",
            shopQtyRefresh: server + "/am/shop/shopQtyRefresh",
            change:server+"/am/shop/change",
            refreshToken:server+"/am/shop/refreshToken",
            getLink:server+"/am/shop/getLink",
            shopOrderUpdateOwner:server+"/am/shop/shopOrderUpdateOwner",
            resendCode:server+"/am/shop/resendCode",
            shopTotal:server+"/am/shop/shopTotal",
            bindMomo:server+"/am/shop/bindMomo",
            updateMomo:server+"/am/shop/updateMomo",
            bindCoupang:server+"/am/shop/bindCoupang",
            updateCoupang:server+"/am/shop/updateCoupang",
        },
        deliveryAddress: {
            list: server+"/am/delivery-addreee/list",
            create: server+"/am/delivery-address/create",
            update: server+"/am/delivery-address/update",
            delete: server+"/am/delivery-address/delete",
        },
        orderCode: {
            list: server+"/am/order-code/list",
            doImport: server+"/am/order-code/doImport",
            delete: server+"/am/order-code/delete",
        },
        shopProduct: {
            autoDayList: server+"/am/product/autoDayList",
            itemList: server+"/am/product/itemList",
        },
        simpleProductName:{
            list:server+"/am/simple-product-name/list",
            titleList:server+"/am/simple-product-name/titleList",
            create:server+"/am/simple-product-name/create",
            update:server+"/am/simple-product-name/update",
            updateRename:server+"/am/simple-product-name/updateRename",
            updateType:server+"/am/simple-product-name/updateType",
            updateProductTypes:server+"/am/simple-product-name/updateProductTypes",
            delete:server+"/am/simple-product-name/delete",
            deleteTitle:server+"/am/simple-product-name/deleteTitle",
            import:server+"/am/simple-product-name/doImport",
        },
        updateColumn:{
            stockCheck:server + "/am/column/stockCheck",
            stockDeclareCheck:server + "/am/column/stockDeclareCheck",
            stockCheckUpdateStatus:server + "/am/column/stockCheckUpdateStatus",
            updateGoodType:server + "/am/column/updateGoodType",
            updatePkgType:server + "/am/column/updatePkgType",//货运代打包
            updateOutType:server + "/am/column/updateOutType",//仓储贴单
            updateReceive:server + "/am/column/updateReceive",//通知收件
            updateCancel:server + "/am/column/cancel",//取消订单
            updateOutTypeFinish:server + "/am/column/updateOutTypeFinish",//完成建单
            updateWeightTime:server + "/am/column/updateWeightTime",
            updatePackType:server + "/am/column/updatePackType",
            updateStatus:server + "/am/column/updateStatus",
            updatePkgTypeToKuaCang:server + "/am/column/updatePkgTypeToKuaCang",
        },
        export:{
            exportExp:server + "/am/export/exportExp",//下载清关资料
            exportHangkong:server + "/am/export/exportHangkong",//下载航空资料
            exportBaoJi:server + "/am/export/exportBaoJi",//下载报机资料
            checkBaoji:server + "/am/export/checkBaoji",//校正报机数据
            exportHeimao:server + "/am/export/exportHeimao",//黑猫派件资料
            exportTihuo:server + "/am/export/exportTihuo",//提货单
            exportJiandan:server + "/am/export/exportJiandan",//建单资料
            tongji:server + "/am/export/tongji",//出货统计
            hqList:server + "/am/export/hqList",//航空清关
            zhaohuoTicket:server + "/am/export/zhaohuoTicket",//转运找货单
            exportDetail:server + "/am/export/exportDetail",//导出详情
            exportBuyDetail:server + "/am/export/exportBuyDetail",//导出详情
            exportResendCost:server + "/am/export/exportResendCost",//导出转寄成本
            exportStatus:server + "/am/export/exportStatus",//导出物流记录
            exportWalletDetailList:server + "/am/export/exportWalletDetailList",//导出运费账单
            exportHistSave:server + "/am/export/exportHistSave",
            getStockReceives:server+"/am/export/getStockReceives",
            exportStockList:server+"/am/export/stock",
            addExportTask:server+"/am/export/stock/addExportTask",  //提交下载任务
            searchProgress:server+"/am/export/stock/searchProgress",  //查询处理任务进度
            continueProcess:server+"/am/export/stock/continueProcess",  //继续处理任务
            downloadPage:server+"/am/export/stock/downloadPage",  //下载查询任务
            exportByKeyword:server+"/am/export/stock/exportByKeyword",//导出关键字
        },
        declare: {  //清关资料
            list: server + "/am/declare/list", //查看列表
            deletes: server+ "/am/declare/deletes", //删除
            creates: server + "/am/declare/creates", //添加
            lock: server + "/am/declare/lock", //添加
            doCount: server + "/am/declare/doCount",
            getCheci: server + "/am/declare/getCheci"
        },
        purchase: {  //采购链接
            list: server + "/am/purchase/list", //查看列表
            listTotal: server + "/am/purchase/listTotal",
            delete: server + "/am/purchase/delete",
            create: server + "/am/purchase/create",
            update: server + "/am/purchase/update",
            updates: server + "/am/purchase/updates",
            updateTypes: server + "/am/purchase/updateTypes",
            imports: server + "/am/purchase/imports",
            importName: server + "/am/purchase/importName",
            updatePurchaseRemark5: server + "/am/purchase/updatePurchaseRemark5",
            updatePurchaseRemark6: server + "/am/purchase/updatePurchaseRemark6",
            getFullLink: server + "/am/purchase/getFullLink",
        },
        pasteRecord:{
            list: server + "/am/paste-record/list", //查看列表
            countUser: server + "/am/paste-record/countUser", //账号统计
            count: server + "/am/paste-record/count", //计数统计
            countDistinct: server + "/am/paste-record/countDistinct", //计数统计
        },
        category: {  
            list: server + "/am/category/list", //查看列表
            delete: server + "/am/category/delete",
            create: server + "/am/category/create",
            update: server + "/am/category/update",
            imports: server + "/am/category/imports",
            importsMultiLine: server + "/am/category/importsMultiLine",
            batchUpdate: server + "/am/category/batchUpdate",
        },
        site:{
            list: server + "/am/site/list", //查看列表
            create: server + "/am/site/create",
            update: server + "/am/site/update",
            delete: server + "/am/site/delete",
            addressList: server + "/am/site/addressList",
            addressCreate: server + "/am/site/addressCreate",
            addressUpdate: server + "/am/site/addressUpdate",
            addressDelete: server + "/am/site/addressDelete",
        },
        expCompanyPage:{
            list: server + "/am/exp-company-page/list", //查看列表
            create: server + "/am/exp-company-page/create",
            update: server + "/am/exp-company-page/update",
            delete: server + "/am/exp-company-page/delete",
            getConfig: server + "/am/exp-company-page/getConfig",
            createConfig: server + "/am/exp-company-page/createConfig",
            updateConfig: server + "/am/exp-company-page/updateConfig",
            updateCode: server + "/am/exp-company-page/updateCode",
        },
        inventoryIn: {  //入库采购单
            list: server+"/am/inventory/in/list",  //列表
            expList: server+"/am/inventory/in/expList",  //列表
            expListTotal: server+"/am/inventory/in/expListTotal",  //列表总条数
            create: server + "/am/inventory/in/create", 
            update: server + "/am/inventory/in/update", 
            deletes: server + "/am/inventory/in/deletes", 
            traces: server + "/am/inventory/in/traces", 
            updateExpCode: server + "/am/inventory/in/updateExpCode", 
            batchUpdate: server + "/am/inventory/in/batchUpdate", 
            expCodeTraces: server + "/am/inventory/in/expCodeTraces", 
            refused: server + "/am/inventory/in/refused", 
            checkRefuse: server + "/am/inventory/in/checkRefuse", 
        },
        printSetting:{
            listTemplate: server + "/am/print-setting/listTemplate", //获取模板列表
            template: server + "/am/print-setting/template", //获取模板具体信息
            updateTemplate: server + "/am/print-setting/updateTemplate", //更新打印模板
            createTemplate: server + "/am/print-setting/createTemplate", //新增打印模板
            deleteTemplate: server + "/am/print-setting/deleteTemplate", //删除打印模板
        },
        shopline:{
            syncMyOrders: server + "/am/shopline/syncMyOrders",
            syncUserOrders: server + "/am/shopline/syncUserOrders",
            syncAllOrders: server + "/am/shopline/syncAllOrders",
        },
        inventory: {
            get: server + "/am/inventory/get",
            list: server + "/am/inventory/list",
            listCount: server+"/am/inventory/listCount",  //列表
            listReceiver: server+"/am/inventory/listReceiver",
            add: server + "/am/inventory/create",
            update: server + "/am/inventory/update",
            deletes: server + "/am/inventory/deletes",
            traces: server + "/am/inventory/traces",  
            outTraces: server + "/am/inventory/outTraces",  
            doImport: server + "/am/inventory/doImport",  
            scanCodeInStore: server + "/am/inventory/scanCodeInStore", //扫码入库
            inoutStoreList: server + "/am/inventory/inoutStoreList", //入库出库list
            updateInventoryQty: server + "/am/inventory/updateInventoryQty", 
            batchUpdate: server + "/am/inventory/batchUpdate", 
            printTag: server + "/am/inventory/printTag", 
            sorting: server + "/am/inventory/sorting", 
            getKuaidiInfo: server + "/am/inventory/getKuaidiInfo", //快递货物查询单号
            updateKuaidiInfo: server + "/am/inventory/updateKuaidiInfo",
            getStoreTypesByStore: server + "/am/inventory/getStoreTypesByStore",
            exportBack: server + "/am/inventory/exportBack",
            doImportBackCode: server + "/am/inventory/doImportBackCode",
            exportTrace: server + "/am/inventory/exportTrace",
            renlingInventory: server + "/am/inventory/renlingInventory",
        },
        inventoryOut: {  //退件，出库
            back: server + "/am/inventory/out/back", 
            cancelBack: server + "/am/inventory/out/cancelBack", 
            receiveBack: server + "/am/inventory/out/receiveBack", 
        },
        checkHist:{
            create:server + "/am/check/hist/create", 
        },
    },
    rebuildQuery: function(query, dateFields){
        var param = {};
        for(var key in query){
            if(key === 'queries') continue;

            var value = query[key];
            if(value===null) {
                continue;
            }else if(value === ""){
                continue;
            }else if(this.isArray(value)){
                if(!dateFields || dateFields.indexOf(key)>-1){
                    try{
                        if(value[0])
                            param["start"+key]=value[0];
                        if(value[1])
                            param["end"+key]=value[1];
                    }catch(err){
                        console.error(err);
                    }
                }else if(value.length>0){
                    param[key] = value;
                }
            }else{
                param[key]=value;
            }
        }
        return param;
    },
    clearQuery: function(query){
        for(var key in query){
            if(key === 'queries') continue;
            if(key=='start') {
                query[key] = 0;
            }else if(key == 'length'){
                continue;
            }else if(key == 'pageIndex')
                query[key] = 1;
            else {
                var val = query[key];
                if(this.isArray(val) && val.length>0){
                    query[key].splice(0, query[key].length);
                }else{
                    query[key] = null;
                }
            }
        }
    },
    isArray : function(arr){
        return Object.prototype.toString.call(arr) === '[object Array]';
    },
    parseVersion: function(version){
        if(version === null || version === undefined){
            return [0, 0, 0];
        }
        if(typeof version === 'number'){
            if(!Number.isFinite(version)){
                return [0, 0, 0];
            }
            return [0, 0, version];
        }
        const raw = String(version).trim().replace(/^v/i, '');
        const parts = raw.split('.');
        const nums = [0, 0, 0];
        for(let i = 0; i < 3; i++){
            const p = parts[i];
            if(p === undefined){
                continue;
            }
            const m = String(p).match(/\d+/);
            nums[i] = m ? Number(m[0]) : 0;
        }
        return nums;
    },
    compareVersion: function(a, b){
        const av = this.parseVersion(a);
        const bv = this.parseVersion(b);
        for(let i = 0; i < 3; i++){
            if(av[i] > bv[i]) return 1;
            if(av[i] < bv[i]) return -1;
        }
        return 0;
    },
    uuuid: function(){
        var s = [];
        var hexDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";
    
        var uuid = s.join("");
        return uuid.replace("-", "");
    },
    buildTree(menus, sort){
        var map = {};
        menus.forEach(m => {
            if(m.parentId === null){
                m.parentId = 0;
            }
            map[m.id] = m;
        });
        
        // let minParent = Math.min(...menus.map(e => e.parentId));
        
        for(let key in map){
            var m = map[key];
            if(m.parentId){ 
                var parent = map[m.parentId];
                if(parent){
                    if(!parent['children']){
                        parent['children'] = [];
                    }

                    parent.children.push(m);
                    m.parent = parent;
                }
            }
        }

        var ms = [];

        for(let key in map){
            let m = map[key];
            if(m.parent == null){
                ms.push(m);
            }
        }
        
        if(sort){
            this.sortTree(ms);
        }
        //ms.sort((a, b) => (b.seq || 0) - (a.seq || 0));

        return ms;
    },
    sortTree(ms){
        ms.sort((a, b) => (a.seq || 0) - (b.seq || 0));
        ms.forEach(m => {
            if(m['children'] && m.children.length>0){
                this.sortTree(m['children']);
            }
        });
    },
    icons: icons.glyphs.map(i => {
            i.font_class = icons.css_prefix_text+i.font_class;
            return i;
        }
    ),
    //格式化日期为： yyyy-MM-dd
    fmtDate(date){
        let m = date.getMonth()+1; 
        let d = date.getDate();
        return date.getFullYear() + "-" + (m<10?('0'+m): m) + "-" + (d<10?('0'+d): d);
    },
    //格式化日期为： yyyy-MM-dd HH:mm:ss
    fmtDateTime(date){
        let m = date.getMonth()+1; 
        let d = date.getDate();
        let h = date.getHours();
        let min = date.getMinutes();
        let sec = date.getSeconds();

        return date.getFullYear() + "-" + (m<10?('0'+m): m) + "-" + (d<10?('0'+d): d) 
            + " "+ (h<10? ('0'+h): h)
            + ":"+ (min<10?('0'+min):min)
            + ":"+ (sec<10?('0'+sec):sec);

    },
    getQueryValue(queryName) {
        var query = decodeURI(window.location.search.substring(1));
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == queryName) { return pair[1]; }
        }
        return null;
    },
    delCookie(name){
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval=this.getCookie(name);
        if(cval!=null)
            document.cookie= name + "="+cval+";expires="+exp.toGMTString()+";path=/";
    },
    setCookie(name,value) {
        var Days = 30;
        var exp = new Date();
        exp.setTime(exp.getTime() + Days*24*60*60*1000);
        document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString()+";path=/";
    },
    getCookie(name){
        var reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        let arr = document.cookie.match(reg);
        if(arr)
            return unescape(arr[2]);
        else
            return null;
    },
    strongAuth(func, page) {
        var _this = this;
        page.$axios.post(_this.api.user.isStrongAuth, "{}").then((res) => {
            if (res.status && res.data) {
                func();
            } else {
                _this.strongAuthData.closeEvent = function (type) {
                    page.strongPwdVisiable = false;
                    if (type) {
                        func();
                    }
                };
                page.strongPwdVisiable = true;
            }
        });
    },
    strongAuthData: {
        closeEvent: null,
        reg: /[^0-9a-zA-Z~!@#$%^&*\-_.]/
    },
    adjustColor(color, amount) {
        // 解析 RGB 颜色
        const rgbMatch = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
        if (rgbMatch) {
          const r = Math.max(0, Math.min(255, parseInt(rgbMatch[1]) + amount));
          const g = Math.max(0, Math.min(255, parseInt(rgbMatch[2]) + amount));
          const b = Math.max(0, Math.min(255, parseInt(rgbMatch[3]) + amount));
          return `rgb(${r}, ${g}, ${b})`;
        }
        
        // 解析 RGBA 颜色
        const rgbaMatch = color.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
        if (rgbaMatch) {
          const r = Math.max(0, Math.min(255, parseInt(rgbaMatch[1]) + amount));
          const g = Math.max(0, Math.min(255, parseInt(rgbaMatch[2]) + amount));
          const b = Math.max(0, Math.min(255, parseInt(rgbaMatch[3]) + amount));
          const a = parseFloat(rgbaMatch[4]);
          return `rgba(${r}, ${g}, ${b}, ${a})`;
        }
        
        // 解析十六进制颜色
        const hexMatch = color.match(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/);
        if (hexMatch) {
          let hex = hexMatch[1];
          // 如果是3位十六进制，转换为6位
          if (hex.length === 3) {
            hex = hex.split('').map(char => char + char).join('');
          }
          
          // 转换为RGB
          const r = parseInt(hex.substr(0, 2), 16);
          const g = parseInt(hex.substr(2, 2), 16);
          const b = parseInt(hex.substr(4, 2), 16);
          
          // 调整颜色
          const newR = Math.max(0, Math.min(255, r + amount));
          const newG = Math.max(0, Math.min(255, g + amount));
          const newB = Math.max(0, Math.min(255, b + amount));
          
          // 转换回十六进制
          const toHex = (num) => {
            const hex = num.toString(16);
            return hex.length === 1 ? '0' + hex : hex;
          };
          
          return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
        }
        
        // 如果不是支持的格式，返回原色
        return color;
      }
            
};

kit.install = function(Vue, options) {
    Vue.kit = kit;
    window.kit = kit;
    Object.defineProperties(Vue.prototype, {
      kit: {
        get() {
          return kit;
        }
      },
      $kit: {
        get() {
          return kit;
        }
      },
    });
  };

export default kit;
